import http from '@/libs/AxiosPlugin'

const collector = {
  list () {
    return http.get('/collectorGroup/list')
    // return new Promise((resolve, reject) => {
    //   let data = [
    //     {id: 1, name: 'group1', collectors: [1], remark: ''}
    //   ]
    //   resolve(data)
    // })
  },

  delete (id) {
    return http.post('/collectorGroup/delete', {id})
  },

  get (id) {
    return http.post('/collectorGroup/get', {id})
  },

  save (c) {
    return http.post('/collectorGroup/save', c)
  }
}

export default collector



// WEBPACK FOOTER //
// ./src/api/collectorGroup.js